<template>
  <div class="container d-flex align-items-center flex-column">
    <div class="maincontent-banner-bg-img d-flex flex-column">
      <section class="d-flex mt-2">
        <div class="col-8 pl-0 pr-1 py-1">
           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li
                v-for="(item, i) in carouselImage"
                :key="'indicators' + i"
                data-target="#carouselExampleIndicators"
                :data-slide-to="i" :class="{'active' : i === 0}">
              </li>
            </ol>
            <div class="carousel-inner">
              <div
                v-for="(item, i) in carouselImage"
                :key="'slide' + i"
                class="carousel-item"
                :class="{'active' : i === 0}"
              >
                <img class="d-block w-100" :src="item.img" :alt="item.alt">
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselExampleIndicators"
              role="button" data-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <div class="col-4 pr-0 pl-1 py-1">
          <img
            class="d-block w-100 mb-1"
            src="../assets/banner/secondary-banner/banner_battleroyal_web.png"
          >
          <img class="d-block w-100 mt-2pc" src="../assets/banner/secondary-banner/HILO.png">
        </div>
      </section>
      <section class="d-flex play-game-bg p-2 mt-2 play-game-banner">
        <h5 class="font-weight-bold m-0 play-game-text">เล่นเกมส์</h5>
      </section>
      <section class="row px-2">
        <div
          data-aos="zoom-in-up" data-aos-duration="500"
          v-for="(data, i) in gamesInfo.filter(item => item.fp_url)"
          :key="'card' + i" class="p-2 col-xl-2 col-lg-3 col-4"
        >
          <div
            class="imgCards click-pointer"
            @click="data.status === 0
              ? onClickCardGames(data) : ''"
            @mouseover="mouseHover(data)"
            @mouseleave="hover = ''"
          >
            <span class="pb-2">
              <img
                v-if="data.imageUrl"
                class="w-100"
                :src="hover === data.name ? data.imageUrl.hover : data.imageUrl.base"
                alt="card_game"
              >
              <img v-else
                class="w-100"
                src="../assets/in-bg-Crime-scene.png"
                alt="crime_scene_card"
              >
              <!-- Desktop -->
              <img
                v-if="data.status === 901"
                class="overlay"
                src="../assets/coming-soon.png"
                alt=""
              >
              <img v-if="data.status === 900" class="overlay" src="../assets/Close-TH.png" alt="">
              <!-- Mobile -->
              <img
                v-if="data.status === 901"
                class="overlay-mobile-disable"
                src="../assets/coming-soon.png"
                alt="mobile-card-disable"
              >
              <img
                v-if="data.status === 900"
                class="overlay-mobile-disable"
                src="../assets/Close-TH.png"
                alt="mobile-card-disable"
              >
              <div v-if="data.status === 0" class="btnLogins">
                <button v-if="util.getUserPersistent().token
                  || (!util.getUserPersistent().token && data.fp_url)"
                  type="button"
                  class="btn-logins btn-success btn-lg" >
                  {{ labelButton }}
                </button>
              </div>
              <div v-if="data.status === 900" class="btnComingSoons">
                <button
                  type="button"
                  class="btn-comingsoons btn-warning btn-lg"
                  disabled>Maintenance
                </button>
              </div>
              <div v-if="![0 , 900].includes(data.status)" class="btnComingSoons">
                <button
                  type="button"
                  class="btn-comingsoons btn-danger btn-lg" disabled >
                  Coming Soon
                </button>
              </div>
            </span>
            <span class="user-online-text">
              จำนวนคนเล่น : {{data.status === 0 ? userOnlineByGamePrefix(data.prefix) : '-'}}
              <!-- จำนวนคนเล่น : {{data.status !== 0 ? "-" : userOnline}} -->
            </span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { GAMES_REQUEST, LAUNCH_GAME_REQUEST } from '../store/actions/games';
import Carousel1 from '../assets/banner/02-min.png';
import Carousel2 from '../assets/banner/03-min.png';
import Carousel3 from '../assets/banner/04-min.png';
import utils from '../services/utils';
// import { GET_STATUS_REQUEST } from '../store/actions/profile';
import { EventBus } from '../services/event-bus';
/* eslint-disable */
  export default {
    name: 'maincontent',
    created() {
      this.getGames()
      this.emitGetUserOnline()
    },
    updated() {
      this.labelButton = utils.getUserPersistent().token ? 'Play' : 'Freeplay'
    },
    data() {
      return {
        util: utils,
        carouselImage: [
          {
            img: Carousel1,
            alt: 'First Slide'
          },
          {
            img: Carousel2,
            alt: 'Second Slide'
          },
          {
            img: Carousel3,
            alt: 'Third Slide'
          },
        ],
        hover: '',
        labelButton: 'Login',
        gamesInfo: [],
        selectedGame: {
          _id: '',
          webUrl: ''
        },
        screenResolution: {
          width: 960,
          height: 540
        },
        isLogin: this.$store.isLogin,
        userOnline: [],
      }
    },
    sockets: {
      gameStatusUpdate(){
        this.getGames()
      },
      updatePlayersNumber(res) {
        const Base64= {
            _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            decode:function(r){var t,e,o,a,h,n,c='',d=0;for(r=r.replace(/[^A-Za-z0-9\+\/\=]/g,'');d<r.length;)t=this._keyStr.indexOf(r.charAt(d++))<<2|(a=this._keyStr.indexOf(r.charAt(d++)))>>4,e=(15&a)<<4|(h=this._keyStr.indexOf(r.charAt(d++)))>>2,o=(3&h)<<6|(n=this._keyStr.indexOf(r.charAt(d++))),c+=String.fromCharCode(t),64!=h&&(c+=String.fromCharCode(e)),64!=n&&(c+=String.fromCharCode(o));return c=Base64._utf8_decode(c)},_utf8_decode:function(r){for(var t='',e=0,o=0,c1=0,c2=0,c3=0;e<r.length;)(o=r.charCodeAt(e))<128?(t+=String.fromCharCode(o),e++):o>191&&o<224?(c2=r.charCodeAt(e+1),t+=String.fromCharCode((31&o)<<6|63&c2),e+=2):(c2=r.charCodeAt(e+1),c3=r.charCodeAt(e+2),t+=String.fromCharCode((15&o)<<12|(63&c2)<<6|63&c3),e+=3);return t}};
          this.userOnline = JSON.parse(Base64.decode(res.data)).data
      },
      updateGameStatus(){
        this.getGames()
      }    
    },
    mounted() {
      EventBus.$on('getgame', () => {
        this.getGames()
      })
    },
    methods: {
      mouseHover(value) {
        this.hover = value.name
      },
      emitGetUserOnline() {
          this.$socket.emit('getWebPlayersNumber', {}, (res) => {
          const Base64= {
            _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            decode:function(r){var t,e,o,a,h,n,c='',d=0;for(r=r.replace(/[^A-Za-z0-9\+\/\=]/g,'');d<r.length;)t=this._keyStr.indexOf(r.charAt(d++))<<2|(a=this._keyStr.indexOf(r.charAt(d++)))>>4,e=(15&a)<<4|(h=this._keyStr.indexOf(r.charAt(d++)))>>2,o=(3&h)<<6|(n=this._keyStr.indexOf(r.charAt(d++))),c+=String.fromCharCode(t),64!=h&&(c+=String.fromCharCode(e)),64!=n&&(c+=String.fromCharCode(o));return c=Base64._utf8_decode(c)},_utf8_decode:function(r){for(var t='',e=0,o=0,c1=0,c2=0,c3=0;e<r.length;)(o=r.charCodeAt(e))<128?(t+=String.fromCharCode(o),e++):o>191&&o<224?(c2=r.charCodeAt(e+1),t+=String.fromCharCode((31&o)<<6|63&c2),e+=2):(c2=r.charCodeAt(e+1),c3=r.charCodeAt(e+2),t+=String.fromCharCode((15&o)<<12|(63&c2)<<6|63&c3),e+=3);return t}};
          this.userOnline = JSON.parse(Base64.decode(res.data)).data
        })
      },
      userOnlineByGamePrefix(prefix) {
        return this.userOnline[prefix]
      },
      getGames() {
        this.$store
          .dispatch(GAMES_REQUEST)
          .then(resp => {
            this.gamesInfo = resp 
            this.emitGetUserOnline()
          })
          .catch(err => {
            if(err === 1002) {
              EventBus.$emit('logOut')
            }
          })
      },
      onClickCardGames(value) {
        this.playGame(value)
        // if (utils.getUserPersistent().token) this.playGame(value)
        // else {
        // EventBus.$emit('logOut')
        // this.$message.error("กรุณา login ใหม่");
        // }
      },
      playGame(value) {
        const isFp = !this.util.getUserPersistent().token && value.fp_url
        const isAuth = this.util.getUserPersistent().token
        if (isAuth) {
          this.$store
          .dispatch(LAUNCH_GAME_REQUEST, {game: value.prefix})
          .then(resp => {
            const Features = 'top=0,left=0,height=768,width=1366,scrollbars=no'
            window.open(resp, "Game", Features)
          })
          .catch(err => {
            if(err === 1002){
            }
          })
        } else if (isFp && !isAuth) {
          const urlGame = isFp ? `${value.fp_url}?language=${'th'}` : `${value.url}?t=${this.$session.get('token')}&language=${'th'}`
          const Features = 'top=0,left=0,height=768,width=1366,scrollbars=no'
          window.open(urlGame, "Game", Features)
        } else {
          return false
        }
        // if(!isFp && !isAuth) return false
        // const urlGame = isFp ? `${value.fp_url}?language=${'th'}` : `${value.url}?t=${this.$session.get('token')}&language=${'th'}`
        // const Features = 'top=0,left=0,height=768,width=1366,scrollbars=no'
        // window.open(urlGame, "Game", Features)
      },
    }  
  }
</script>

<style scoped>
.play-game-bg {
  background-color: #fde60c;
}
.play-game-text {
  color: #008f6b;
}
.user-online-text {
  color: #fde60c
}
.mt-2pc {
  margin-top: 2%
}
.maincontent-banner-bg-img {
  background: transparent;
  width: 80%;
  height: auto;
  padding-bottom: 0px;
  border-radius: 0px 0px 10px 10px;
}
.play-game-banner {
  border-radius: 5px;
}
@media only screen and (max-width: 576px) {
  .overlay {
    display: none !important;
  }
  .btn-logins {
    display: none !important;
  }
  .btn-comingsoons {
    display: none !important;
  }
}
@media only screen and (min-width: 576px) {
  .overlay-mobile {
    display: none !important;
  }
  .overlay-mobile-disable {
    display: none !important;
  }
}
.overlay {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  transition: background 0.5s ease;
}
.overlay-mobile {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  transition: background 0.5s ease;
}
.overlay-mobile-disable {
  position: absolute;
  top: 0;
  left: 0%;
  max-width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 1;
}
.imgCards:hover .overlay {
  display: block;
  background: rgba(0, 0, 0, 0.3);
}
.btnLogins {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  text-align: center;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.btn-logins {
  border-radius: 5px;
  border-color: transparent;
  background: linear-gradient(to bottom, #32a876, #43de84);
  font-weight: bold;
  line-height: 0.9;
  font-size: 1em;
  padding: 6% 18%;
  color: black;
}
.btn-logins:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
  color: white;
}
.btnComingSoons {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  text-align: center;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.btn-comingsoons {
  border: solid 1px white;
  line-height: 0.9;
  font-size: 1em;
  padding: 10% 10%;
}
.btn-comingsoons:hover {
  color: white;
}
@media only screen and (max-width: 768px) {
  .btn-comingsoons {
    font-size: 0.7em !important;
  }
}
.imgCards:hover .btnLogins {
  opacity: 1;
}
.imgCards:hover .btnComingSoons {
  opacity: 1;
}
.img-playgame {
  height: auto;
  width: 15%;
}
.card-container {
  padding: 0.5rem;
  background-color: transparent;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>

